exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.land-signature-pad[data-v-ce8a48c8] {\nborder: 1px solid salmon;\nborder-radius: 25px;\nmax-width: 400px;\n}\n.canvas-box[data-v-ce8a48c8] {\nborder-radius: 25px;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\nmin-height: 120px;\n}\n.font-size-li[data-v-ce8a48c8]{\nfont-size: 18px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-ce8a48c8","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nimcap/Components/Guarantor/Step6.vue
// module id = 2295
// module chunks = 0